import { render, staticRenderFns } from "./BankBalance.vue?vue&type=template&id=7ebec9c6"
import script from "./BankBalance.vue?vue&type=script&lang=ts"
export * from "./BankBalance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ebec9c6')) {
      api.createRecord('7ebec9c6', component.options)
    } else {
      api.reload('7ebec9c6', component.options)
    }
    module.hot.accept("./BankBalance.vue?vue&type=template&id=7ebec9c6", function () {
      api.rerender('7ebec9c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bank/BankBalance.vue"
export default component.exports